const mutations = {
  ALL_SUBSCRIPTIONS(state, data) {
    state.allSubscriptions = data;
  },
  SUBSCRIPTION(state, data) {
    state.subscription = data;
  },
  SUBSCRIPTION_TEMPORAL(state, data) {
    state.subscriptionTemporal = data;
  },
  SUBSCRIPTIONS_OVERLAY(state, data) {
    state.subscriptionsOverlay = data;
  },
  MENUS(state, data) {
    state.menus = data;
  },
  MENU_OPTIONS(state, data) {
    state.menuOptions = data;
  },
  PLATES_OPTIONS(state, data) {
    state.platesOptions = data;
  },
  TAGS(state, data) {
    state.tags = data;
  },
  INGREDIENTS(state, data) {
    state.ingredients = data;
  },
  MENU_ITEMS(state, data) {
    state.menuItems = data;
  },
  CURRENT_MENU(state, data) {
    state.currentMenu = data;
  },
  CURRENT_MENU_OPTION(state, data) {
    state.currentMenuOption = data;
  },
  CURRENT_DAY(state, data) {
    state.currentDay = data;
  },
  ALL_MENU_ITEM_PRODUCTS(state, data) {
    const menus = [...data];
    const response = [];
    const alreadyExists = (itemId) => {
      let exists = false;
      if(response && response.length) {
        const findIndex = response.findIndex((item) => item.id === itemId);
        if(findIndex !== -1) {
          exists = true;
        }
      }
      return exists;
    };
    if(menus && menus.length) {
      menus.map((menu) => {
        if(menu.menu_options && menu.menu_options.length) {
          menu.menu_options.map((menuOption) => {
            if(menuOption.menu_items && menuOption.menu_items.length) {
              menuOption.menu_items.map((menuItem) => {
                if(menuItem.products_details && menuItem.products_details.length) {
                  menuItem.products_details.forEach((element) => {
                    if(!alreadyExists(element.id)) {
                      response.push({
                        ...element,
                        menu_id: menu.id,
                        menu_option_id: menuOption.id,
                        menu_item_id: menuItem.id
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    } 
    state.allMenuItemProducts = response;
  }
};

export default mutations
